import { useTranslation } from 'react-i18next'
import { CategoryArchive } from '@/components/sections'
import type { Line } from '@/data/products'

const lineOrder: Line[] = ['body-cleansing', 'body-care']

export function CategoryCorpoPage() {
  const { t } = useTranslation('common')
  return (
    <CategoryArchive
      category="corpo"
      lineOrder={lineOrder}
      hero={{
        eyebrow: t('categoryCorpo.hero.eyebrow'),
        title: t('categoryCorpo.hero.title'),
        titleItalic: t('categoryCorpo.hero.titleItalic'),
        intro: t('categoryCorpo.hero.intro'),
        image: '/images/categories/corpo-hero.webp',
        imageAlt: t('categoryCorpo.hero.imageAlt'),
      }}
      faq={{
        eyebrow: t('categoryCorpo.faq.eyebrow'),
        title: t('categoryCorpo.faq.title'),
        titleItalic: t('categoryCorpo.faq.titleItalic'),
        body: (
          <>
            <p>{t('categoryCorpo.faq.bodyParagraph1')}</p>
            <p>
              <strong className="text-bruno">{t('categoryCorpo.faq.bodyQuestion')}</strong>{' '}
              {t('categoryCorpo.faq.bodyParagraph2')}
            </p>
          </>
        ),
      }}
      labels={{
        filterByLine: t('categoryCorpo.archiveLabels.filterByLine'),
        scrollLeft: t('categoryCorpo.archiveLabels.scrollLeft'),
        scrollRight: t('categoryCorpo.archiveLabels.scrollRight'),
        all: t('categoryCorpo.archiveLabels.all'),
        linePrefix: t('categoryCorpo.archiveLabels.linePrefix'),
        productsSuffix: t('categoryCorpo.archiveLabels.productsSuffix'),
        defaultEyebrow: t('categoryCorpo.archiveLabels.defaultEyebrow'),
        defaultFaqEyebrow: t('categoryCorpo.archiveLabels.defaultFaqEyebrow'),
        categoryAriaLabel: t('categoryCorpo.hero.ariaLabel'),
      }}
    />
  )
}
